import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'nameTransform',
    standalone: false
})
export class NameTransformPipe implements PipeTransform {
  transform(
    value: { nameTilt: number },
    config: { childPhotoNameToPhotoGap: number },
  ): unknown {
    const transforms = [];
    if (value.nameTilt) {
      transforms.push(`rotate(${value.nameTilt}deg)`);
    }
    if (config.childPhotoNameToPhotoGap < 0) {
      transforms.push(`translateY(${config.childPhotoNameToPhotoGap}px)`);
    }
    return transforms.join(' ');
  }
}
